// @flow

import React from "react";
import { localize } from "redux-i18n";
import { SimpleGrid, WistiaPlayer } from "@components";

type Props = PropsFromLocalize;

class HelpPanelRTWInterviews extends React.Component<Props> {
  get typeData() {
    return [
      {
        id: "standart-reports",
        label: this.props.t("STANDART_REPORTS"),
        details: this.props.t("STANDART_REPORTS_INTRODUCTION"),
      },
      {
        id: "my-reports",
        label: this.props.t("MY_REPORTS"),
        details: this.props.t("MY_REPORTS_INTRODUCTION"),
      },
    ];
  }

  get formatData() {
    return [
      {
        id: "last-rtw-reasons",
        label: this.props.t("LATE_RTW_REASONS"),
        details: this.props.t("LAST_RTW_REASONS_DESCRIPTION"),
      },
      {
        id: "rtw-completed",
        label: this.props.t("RTWS_COMPLETED_ON_TIME"),
        details: this.props.t("RTW_COMPLETED_ON_TIME_DESCRIPTION"),
      },
      {
        id: "filters",
        label: this.props.t("QUICK_FILTERS"),
        details: this.props.t("QUICK_FILTERS_DESCRIPTION"),
      },
      {
        id: "export-button",
        label: this.props.t("EXPORT_BUTTON"),
        details: this.props.t("EXPORT_BUTTON_DESCRIPTION"),
      },
    ];
  }

  get filtersData() {
    return [
      {
        id: "date-range",
        label: this.props.t("DATE_RANGE"),
        details: this.props.t("DATE_RANGE_DESCRIPTION"),
      },
      {
        id: "from-date",
        label: this.props.t("FROM_DATE"),
        details: this.props.t("RTW_FROM_DATE_DESCRIPTION"),
      },
      {
        id: "to-date",
        label: this.props.t("TO_DATE"),
        details: this.props.t("TO_DATE_DESCRIPTION"),
      },
      {
        id: "status",
        label: this.props.t("STATUS"),
        details: this.props.t("RTW_STATUS_DESCRIPTION"),
      },
      {
        id: "absence-type",
        label: this.props.t("REPORT_COLUMN_ABSENCE_TYPE"),
        details: this.props.t("RTW_ABSENCE_TYPE_DESCRIPTION"),
      },
      {
        id: "absence-length",
        label: this.props.t("ABSENCE_LENGTH"),
        details: this.props.t("RTW_ABSENCE_LENGTH_DESCRIPTION"),
      },
      {
        id: "include-leavers",
        label: this.props.t("INCLUDE_LEAVERS"),
        details: this.props.t("RTW_INCLUDE_LEAVERS_DESCRIPTION"),
      },
      {
        id: "with-disability",
        label: this.props.t("INCLUDE_EMPLOYEE_WITH_DISABILITY"),
        details: this.props.t("ALERT_EMPLOYEE_WITH_DISABILITY_DESCRIPTION"),
      },
      {
        id: "my-forms",
        label: this.props.t("MY_RTW_FORMS_ONLY"),
        details: this.props.t("RTW_MY_FORMS_DESCRIPTION"),
      },
      {
        id: "absence-reasons",
        label: this.props.t("ABSENCE_REASONS"),
        details: this.props.t("RTW_ABSENCE_REASONS_DESCRIPTION"),
      },
      {
        id: "staff-groups",
        label: this.props.t("STAFF_GROUPS"),
        details: this.props.t("RTW_STAFF_GROUPS_DESCRIPTION"),
      },
    ];
  }

  get resultsData() {
    return [
      {
        id: "employee-ref",
        label: this.props.t("EMPLOYEE_REF"),
        details: this.props.t("EMPLOYEE_REF_DESCRIPTION"),
      },
      {
        id: "department",
        label: this.props.t("DEPARTMENT"),
        details: this.props.t("DEPARTMENT_DESCRIPTION"),
      },
      {
        id: "absence-start",
        label: this.props.t("REPORT_COLUMN_ABSENCE_START"),
        details: this.props.t("AD_START_DATE_DESCRIPTION"),
      },
      {
        id: "rtw-date",
        label: this.props.t("RTW_DATE"),
        details: this.props.t("AD_RTW_DATE_DESCRIPTION"),
      },
      {
        id: "date-triggered",
        label: this.props.t("REPORT_COLUMN_ABSENCE_TYPE"),
        details: this.props.t("AD_RESULTS_ABSENCE_TYPE_DESCRIPTION"),
      },
      {
        id: "rtw-due-date",
        label: this.props.t("REPORT_COLUMN_RTW_DUE_DATE"),
        details: this.props.t("RTW_DUE_DATE_DESCRIPTION"),
      },
      {
        id: "date-interview-completed",
        label: this.props.t("REPORT_COLUMN_DATE_INTERVIEW_COMPLETED"),
        details: this.props.t("RTW_DATE_COMPLETED_DESCRIPTION"),
      },
      {
        id: "completed-by",
        label: this.props.t("REPORT_COLUMN_INTERVIEW_COMPLETED_BY"),
        details: this.props.t("RTW_COMPLETED_BY_DESCRIPTION"),
      },
      {
        id: "hours-to-complete",
        label: this.props.t("HOURS_TAKEN"),
        details: this.props.t("RTW_HOURS_TO_COMPLETE_DESCRIPTION"),
      },
      {
        id: "compliant",
        label: this.props.t("REPORT_COLUMN_RTW_COMPLIANT"),
        details: this.props.t("RTW_COMPLIANT_DESCRIPTION"),
      },
    ];
  }

  get columns() {
    return [
      {
        title: this.props.t("ITEM"),
        name: "setting",
        width: 110,
        renderItem: item => item.label,
      },
      {
        title: this.props.t("DESCRIPTION"),
        name: "details",
        renderItem: item => item.details,
      },
    ];
  }

  render() {
    return (
      <div>
        <p className="fs-14">{this.props.t("RTW_INTRODUCTION")}</p>
        <h6 className="font-weight-bold">{this.props.t("TUTORIAL")}</h6>
        <div className="mb-3">
          <WistiaPlayer
            videoId={WistiaPlayer.videos.RTW_INSTRUCTIONS}
            title={this.props.t("RTW_INSTRUCTIONS")}
          />
        </div>
        <h6 className="font-weight-bold">{this.props.t("TYPE")}</h6>
        <SimpleGrid className="theme-help" columns={this.columns} rows={this.typeData} />
        <h6 className="font-weight-bold">{this.props.t("FORMAT")}</h6>
        <SimpleGrid className="theme-help" columns={this.columns} rows={this.formatData} />
        <h6 className="font-weight-bold">{this.props.t("FILTERS")}</h6>
        <SimpleGrid className="theme-help" columns={this.columns} rows={this.filtersData} />
        <h6 className="font-weight-bold">{this.props.t("RESULTS")}</h6>
        <SimpleGrid className="theme-help" columns={this.columns} rows={this.resultsData} />
      </div>
    );
  }
}

export default localize()(HelpPanelRTWInterviews);
